import Vue from "vue";
import { sync } from "vuex-router-sync";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueScrollTo from "vue-scrollto";

Vue.use(VueScrollTo);

sync(store, router);

const app = new Vue({
  router,
  store,
  ...App
});

export { app, router, store };



// WEBPACK FOOTER //
// ./client/app.js